import { render, staticRenderFns } from "./shortTermReturnList.vue?vue&type=template&id=aa6c37f0"
import script from "./shortTermReturnList.vue?vue&type=script&lang=js"
export * from "./shortTermReturnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports